export function showVideo(url, size, html) {
    const featuresProps = {
        width: size.width,
        height: size.height,
    };
    let windowOpen = window.open(url, "videoPlayer" + url, windowFeaturesToString(featuresProps));
    //let windowOpen =  window.open(url, "_self", 'noopener, noreferrer')
    if(html) windowOpen.document.write(html);

    return (!windowOpen || windowOpen.closed || typeof windowOpen.closed=='undefined')? false:true;
}

function windowFeaturesToString(props) {
    return Object.keys(props)
        .filter(key => typeof props[key] !== "undefined")
        .map(key => `${key}=${props[key]}`)
        .join();
}